import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../auth/useAuth";

interface AdminOnlyRouteProps {
  children: React.ReactElement;
}

// =============================================
// Wraps a route so that it is accessible only
// to authenticated users who have the admin role.
//
// Unauthenticated visitors are sent to /login.
// Authenticated non-admin users are sent to
// /history so they see the appropriate page
// without a confusing blank screen.
//
// isLoading is held for while the auth context
// resolves the session and profile on first paint.
// =============================================
const AdminOnlyRoute: React.FC<AdminOnlyRouteProps> = ({ children }) => {
  const authContext = useAuth();

  if (authContext.isLoading) {
    return <div>Loading...</div>;
  }

  if (!authContext.session) {
    return <Navigate to="/login" replace />;
  }

  if (authContext.userProfile?.role !== "admin") {
    return <Navigate to="/history" replace />;
  }

  return children;
};

export default AdminOnlyRoute;
